<merchant-account-notification #notificationElement></merchant-account-notification>